/**
 * Formats a price number with space as thousands separator
 * @param price - The price number to format
 * @returns Formatted price string with spaces (e.g., "49 990")
 */
export function formatPrice(price: number): string {
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}
